<template>
	<div class="results">
		<!-- 主视觉区域 -->
		<section class="hero">
			<div class="container">
				<div class="hero-content">
					<div class="search-container">
						<div class="search-tabs">
							<el-radio-group v-model="radio1" size="large" @change="handleRadioChange">
								<el-radio-button label="1">站内检索</el-radio-button>
								<el-radio-button label="2">Ai问答</el-radio-button>
							</el-radio-group>
						</div>
						<div class="search-box" v-if="radio1 === '1'">
							<el-input v-model="input" size="large" placeholder="请输入关键字查询相关内容" clearable @keyup.enter="handleSearch" @clear="handleClear"/>
							<el-button type="primary" class="search-btn" size="large" @click="handleSearch">搜索</el-button>
						</div>
						<!-- <div class="search-box" v-else>
							<el-input 
								v-model="input" 
								size="large" 
								resize="none" 
								:rows="3" 
								type="textarea" 
								placeholder="给AI搜索发送消息"
								@keyup.enter.ctrl="handleSearch"
							></el-input>
							<div class="send-btn" @click="handleSearch">
								<img src="@/assets/images/send-icon.png" class="send-icon" alt="AI搜索" />
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</section>

		<!-- 左侧导航 + 右侧内容区域 -->
		<section class="content-section">
			<div class="container">
				<div class="content-layout" v-if="filteredArticleList.length == 0">
					<!-- 左侧导航 -->
					<div class="sidebar">
						<div class="sidebar-menu">
							<div 
								v-for="(item, index) in sliderList" 
								:key="index" 
								:class="activeIndex === index ? 'menu-item active' : 'menu-item'" 
								@click="handleCategoryChange(item,index)"
							>
								<span>{{item.name}}</span>
							</div>
						</div>
					</div>

					<!-- 右侧内容区域 -->
					<div class="main-content">
						<el-loading v-if="loading" :fullscreen="true" />

						<!-- 研究报告区域 -->
						<template v-if="researchReports.length > 0">
							<div class="topic-summary" v-for="(report, index) in researchReports" :key="'report-' + index">
								<div class="summary-card">
									<div class="summary-content">
										<div class="topic-title" @click="handleReportDetail(activeIndex,report.code)" v-if="radio1 === '1'">{{ report.title }}</div>
										<div class="topic-title" @click="handleReportDialog(report.code)" v-if="radio1 === '2'">{{ report.title }}</div>
										<div class="topic-info">
											<span class="topic-source">{{ report.source }}</span>
											<span class="topic-time">{{ report.publishTime }}</span>
										</div>
										<p>{{ report.summary }}</p>
										<div class="download-area" v-if="activeIndex === 0">
											<div class="file-info">
												<img :src="report.fileImg" alt="资料文件">
												<span v-if="radio1 === '1'">{{ '资料文件' }}</span>
											</div>
											<button class="btn-download" @click="handleDownload(report.titleShort)" v-if="radio1 === '1'">
												{{ index === 0 && isLogin ? '下载' : '登录下载' }}
											</button>
                      <button class="btn-download" @click="handleReportDialog(report.code)" v-if="radio1 === '2'">
												{{ index === 0 && isLogin ? '查看' : '登录查看' }}
											</button>
										</div>
									</div>
								</div>
							</div>
							<div class="pagination-container">
								<el-pagination 
									v-model:current-page="currentPage1" 
									:page-size="10" 
									:size="isMobile ? 'small' : 'default'" 
									:background="true"
									:pager-count="isMobile ? 5 : 7"
									layout="total, prev, pager, next"
									:total="total"
									@current-change="handleCurrentChange"
									class="responsive-pagination"
								/>
							</div>
						</template>
						<!-- 无数据时显示 -->
						<el-empty v-if="researchReports.length === 0 && !loading" description="暂无数据"></el-empty>
					</div>
				</div>
        <div class="content-layout" v-else>
					<!-- 右侧内容区域 -->
					<div class="main-content">
						<el-loading v-if="loading" :fullscreen="true" />

						<!-- 研究报告区域 -->
						<template v-if="researchReports.length > 0">
							<div class="topic-summary" v-for="(report, index) in filteredArticleList" :key="'report-' + index">
								<div class="summary-card">
									<div class="summary-content">
										<div class="topic-title" @click="handleReportDetail(activeIndex,report.code,report.sectionCode)">{{ report.title }}</div>
										<div class="topic-info">
											<span class="topic-source">{{ report.source }}</span>
											<span class="topic-time">{{ report.publishTime }}</span>
										</div>
										<p>{{ report.summary }}</p>
										<div class="download-area" v-if="report.sectionCode === 'news-dhcg-fbhsl'">
											<div class="file-info">
												<img :src="report.fileImg" alt="资料文件">
												<span v-if="radio1 === '1'">{{ '资料文件' }}</span>
											</div>
											<button class="btn-download" @click="handleDownload(report.titleShort)">
												{{ index === 0 && isLogin ? '下载' : '登录下载' }}
											</button>
										</div>
									</div>
								</div>
							</div>
							<div class="pagination-container">
								<el-pagination 
									v-model:current-page="currentPage1" 
									:page-size="10" 
									:size="isMobile ? 'small' : 'default'" 
									:background="true"
									:pager-count="isMobile ? 5 : 7"
									layout="total, prev, pager, next"
									:total="total"
									@current-change="handleCurrentChange"
									class="responsive-pagination"
								/>
							</div>
						</template>
						<!-- 无数据时显示 -->
						<el-empty v-if="researchReports.length === 0 && !loading" description="暂无数据"></el-empty>
					</div>
				</div>
			</div>
		</section>
    <el-dialog v-model="dialogVisible" width="50%" >
      <div class="markdown-content" v-html="AIContent" v-loading="loading" element-loading-text="AI思考中..."></div>
    </el-dialog>

    <!-- <section class="content-section" v-if="radio1 === '2'">
      <div class="container">
        <div class="content-layout content-layout1">
          <div class="report-card" v-for="(report, index) in researchAIMB" :key="'report-' + index" @click="handleReportDialog(report.code)">
            <div class="report-content">
              <h3 class="report-title">{{ report.title }}</h3>
              <p class="report-summary">{{ report.summary }}</p>
            </div>
            <div class="report-image">
              <img :src="report.fileImg" v-if="report.fileImg" alt="报告封面">
            </div>
          </div>
        </div>
      </div>
    </section> -->
	</div>
</template>

<script>
import { ref, onMounted, } from 'vue';
import { resultsService } from '@/service';
import { ElMessage } from 'element-plus';
import $api from '@/api/urls'
import { marked } from 'marked';

export default {
  name: 'Results',
  setup() {
    // 数据
    const radio1 = ref('1');
    const AIContent = ref('');
    const dialogVisible = ref(false);
    const input = ref('');
    const currentPage1 = ref(1);
    const total = ref(0);
    const activeIndex = ref(0);
    let sliderList = ref([]);
    const totalList = ref([]);
    const researchAIMB = ref([]);
    let isLogin = ref(localStorage.getItem('token') ? true : false);
    const size = ref('default')
    // 研究报告列表
    const researchReports = ref([]);
    // 加载状态
    const loading = ref(false);
    const fileDownload = ref($api.DOWNLOAD_FILE);
    const articleList = ref([]);
    const filteredArticleList = ref([]);
    
    // 获取栏目-左侧菜单
    const getResearchReports = async () => {
      try {
        loading.value = true;
        const res = await resultsService.getSectionMenu();
        if (res && res.data.code === '0000') {
          totalList.value = res.data.list;
          postAllArticle();
          sliderList.value = res.data.list[0].children;
          getReports(sliderList.value[0]);
        } 
      } catch (error) {
        console.error('获取栏目失败:', error);
      } finally {
        loading.value = false;
      }
    };

    const postAllArticle = async () => {
      let list = [];
      totalList.value[0].children.forEach(item=>{
        list.push(item.code);
      })
      const res = await resultsService.getLatestArticle(list);
      if(res && res.data.code === '0000'){
        articleList.value = res.data.list;
      }
      console.log('获取全部文章:', res);
    };

    const getReports = async (item) => {
      try {
        loading.value = true;
        const res = await resultsService.getReportsBySection(item,currentPage1.value,10);
        if (res && res.data.code === '0000') {
          researchReports.value = res.data.list.map(item=>{
            item.fileImg = fileDownload.value + "?fileId=" + item.fileId + "&free=1"; // 封面图片全路径
            return item;
          });
          total.value = res.data.total;
        }
      } catch (error) {
        console.error('获取内容失败:', error);
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = async () => {
      if (!input.value.trim()) {
        ElMessage.warning('请输入搜索关键词');
        return;
      }
      
      // 获取搜索关键词并转为小写
      const searchTerm = input.value.trim().toLowerCase();
      
      // 在 articleList 中进行模糊匹配
      let results = articleList.value.filter(article => {
        const title = article.title ? article.title.toLowerCase() : '';
        const summary = article.summary ? article.summary.toLowerCase() : '';
        
        return title.includes(searchTerm) || summary.includes(searchTerm);
      });
      filteredArticleList.value = results;
      if(results.length == 0) {
        ElMessage.warning('暂无相关内容');
      }
    };
    
    // 下载文件
    const handleDownload = async (fileIdStr) => {
      if(!isLogin.value) {
        ElMessage.warning('请登录后下载');
        return;
      }
      try {
        loading.value = true;
        let fileId = fileIdStr.split('|')[0];
        let fileName = fileIdStr.split('|')[1];
        await resultsService.downloadFile(fileId,fileName);
        sendLog(fileName);
      } catch (error) {
        console.error('下载失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const  sendLog = async (fileName) => {
      let obj = {
        "businessType": '下载',//业务名称 
        "businessTypeCode":'download',//  业务编码 
        "channelCode": "home",//渠道编码（大平台渠道编码）
        "client": "中国企业走出去",//客户端类型（用户中心）
        "clientCode": "ceggrc-web-2025",// 客户端编码 
        "operationContent": fileName, //业务内容
        "operationType": '下载', //操作类型类型,渠道自定
        "operationTypeCode": 'download',// 操作类型编码,渠道自定 
        "userCode": localStorage.getItem('userCode') ?localStorage.getItem('userCode') : '',//用户编码（用户中心编码）
				"userIp": '',//用户ip
				"userName": localStorage.getItem('userName') ? localStorage.getItem('userName') : ''//用户名称（用户中心）
			};
      await resultsService.sendRecord(obj);
  }
    
    // 切换分类
    const handleCategoryChange = (item,index) => {
      activeIndex.value = index;
      // 根据分类加载不同数据
      getReports(item);
    };
    const handleCurrentChange = (val) => {
      currentPage1.value = val;
      getReports(sliderList.value[activeIndex.value]);
    };

    const handleReportDetail = (index,code,sectionCode1) => {
      let sectionCode = sectionCode1 ? sectionCode1 : sliderList.value[index].code;
      window.open(
          "/articleDetails" +
          "?sectionCode=" + 
           sectionCode +
          "&articleCode=" +
          code
      );
    };
    const handleReportDialog = (code) => {
      if(!isLogin.value) {
        ElMessage.warning('请登录后查看');
        return;
      }
      AIContent.value = '';
      dialogVisible.value = true;
      loading.value = true;
      let params = "/home/ceggrc-web-2025/" + totalList.value[1].children[0].code + "/" + code;
      resultsService.getArticleDetail(params)
        .then(res => {
          if(res.data.code == '0000' && res.data.data) {
            let obj = {
                "keyValues": [
                    {
                        "key": "information",
                        "value": res.data.data.content.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '')
                    }
                ],
                "templateCode": "ceggrc-2025-0320"
            }
            resultsService.postGPTAPIKey(obj)
              .then(res => {
                if(res.data.code == '0000' && res.data.data) {
                  loading.value = false;
                  let html = convertMarkdownToHtml(res.data.data);
                  AIContent.value = html;
                }
              })
              .catch(error => {
                console.error(error);
              });
          } else {
            loading.value = false;
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          loading.value = false;
          console.error(error);
          this.$message.error("系统错误, 请稍后刷新重试");
        });
    };
    const handleRadioChange = (val) => {
      if(val === '1') {
        sliderList.value = totalList.value[0].children;
      } else {
        sliderList.value = totalList.value[1].children;
      }
      getReports(sliderList.value[0]);
    };
    const getResearchAIMB = async () => {
      try {
        loading.value = true;
        const res = await resultsService.getReportsBySection(totalList.value[1].children[0],1,10);
        if (res && res.data.code === '0000') {
          researchAIMB.value = res.data.list.map(item=>{
            item.fileImg = item.fileId ? fileDownload.value + "?fileId=" + item.fileId + "&free=1" : ''; // 封面图片全路径
            return item;
          });
        }
      } catch (error) {
        console.error('获取内容失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const convertMarkdownToHtml = (markdownData) => {
      
      // 提取Markdown内容 (去除```markdown和```标记)
      const markdownContent = markdownData.trim()
        .replace(/```markdown\n/, '')
        .replace(/\n```$/, '');
      
      // 转换Markdown为HTML
      const html = marked.parse(markdownContent);
      
      return html;
};
const handleClear = () => {
  filteredArticleList.value = [];
  getResearchReports();
}
    
    // 组件挂载时加载数据
    onMounted(() => {
      // 默认加载研究报告
      getResearchReports();
      isLogin.value = localStorage.getItem('token') ? true : false;
    });
    
    return {
      dialogVisible,
      AIContent,
      radio1,
      size,
      isLogin,
      input,
      currentPage1,
      totalList,
      researchAIMB,
      articleList,
      total,
      activeIndex,
      sliderList,
      researchReports,
      loading,
      handleSearch,
      handleDownload,
      handleRadioChange,
      getResearchAIMB,
      handleCurrentChange,
      handleCategoryChange,
      handleReportDialog,
      handleReportDetail,
      postAllArticle,
      convertMarkdownToHtml,
      filteredArticleList,
      handleClear,
    };
  }
}
</script>

<style scoped>
.results {
  width: 100%;
}

/* 主视觉区域样式 */
.hero {
  /* background: url('@/assets/images/dh-banner.png') 100% 100% no-repeat; */
  height: 500px;
  display: flex;
  align-items: center;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/dh-banner.png');
  background-size: cover;
  background-position: center;
  opacity: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  text-align: center;
  margin-top: 240px;
  height: 200px;
}

.hero h1 {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
}

.search-container {
  max-width: 500px;
  margin: 0 auto;
  border-radius: 4px;
  overflow: hidden;
  text-align: center;
}

.search-tabs {
  border-radius: 4px;
}

.search-tab {
  flex: 1;
  padding: 10px 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  color: #666;
  transition: all 0.3s;
}

.search-tab.active {
  color: #004a99;
  font-weight: bold;
  position: relative;
}

.search-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #004a99;
}

.search-box {
  display: flex;
  padding: 5px;
  margin-top: 30px;
  border-radius: 4px;
  position: relative;
}

.search-btn {
  margin-left: 10px;
  color: #073A90;
  font-weight: bold;
  /* font-size: 20px; */
}
.send-btn {
	width: 20px;
	height: 20px;
	background: #073A90;
	border-radius: 50%;
	position: absolute;
    bottom: 7px;
    z-index: 2;
    right: 9px;
	cursor: pointer;
}

.send-icon {
  width: 15px;
  height: 15px;
}

/* 内容区域样式 */
.content-section {
  padding: 30px 0;
  background-color: #f5f5f5;
}

.content-layout {
  display: flex;
  gap: 20px;
}
.content-layout1 {
  display: block;
  padding: 0 180px;
}

/* 左侧导航样式 */
.sidebar {
  width: 200px;
  flex-shrink: 0;
}

.sidebar-menu {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.menu-item {
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  margin: 10px 20px;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item span {
  color: #333;
  font-size: 0.95rem;
}

.menu-item.active {
	background: #073A90;
	border-radius: 8px;
}

.menu-item.active span {
  color: #fff;
  font-weight: bold;
}

.menu-item:hover:not(.active) {
  background-color: #f9f9f9;
}

/* 右侧内容区域样式 */
.main-content {
  flex: 1;
}

.topic-header {
  margin-bottom: 20px;
}

.topic-header h2 {
  font-size: 1.3rem;
  color: #333;
  font-weight: bold;
  position: relative;
  padding-left: 15px;
}

.topic-header h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 18px;
  background-color: #004a99;
}

.topic-summary {
  margin-bottom: 20px;
}

.summary-card {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.summary-content {
  padding: 20px;
}

.summary-content p {
  margin-bottom: 20px;
  line-height: 1.8;
  color: #555;
}
.topic-title {
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	line-height: 28px;
	text-align: left;
	font-style: normal;
	margin-bottom: 12px;
  cursor: pointer;
}
.topic-info {
	font-weight: 400;
	font-size: 14px;
	color: #999999;
	line-height: 20px;
	font-style: normal;
	margin-bottom: 12px;
}
.topic-source {
	margin-right: 10px;
}

.download-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.file-info {
  display: flex;
  align-items: center;
}

.file-info img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.file-info span {
  color: #666;
}

.btn-download {
  background-color: #004a99;
  color: white;
  border: none;
  padding: 8px 20px;
  font-size: 0.9rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-download:hover {
  background-color: #003a79;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero h1 {
    font-size: 1.6rem;
  }
  
  .search-container {
    max-width: 90%;
  }
}

@media (max-width: 768px) {
  .hero {
    height: 220px;
    padding: 20px 0;
  }
  
  .hero h1 {
    font-size: 1.4rem;
    padding: 0 15px;
    margin-bottom: 1.2rem;
  }
  
  .search-tab {
    padding: 8px 0;
    font-size: 0.85rem;
  }
  
  .search-box input {
    padding: 8px 10px;
    font-size: 0.85rem;
  }
  
  .content-layout {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .sidebar-menu {
    display: flex;
    flex-wrap: wrap;
  }
  
  .menu-item {
    flex: 1;
    min-width: 120px;
    text-align: center;
    padding: 10px;
    border-bottom: none;
    border-right: 1px solid #eee;
  }
  
  .menu-item:last-child {
    border-right: none;
  }
}

@media (max-width: 576px) {
  .hero {
    height: 240px;
  }
  
  .hero h1 {
    font-size: 1.2rem;
    line-height: 1.5;
  }
  
  .sidebar-menu {
    flex-direction: column;
  }
  
  .menu-item {
    border-right: none;
    border-bottom: 1px solid #eee;
  }
  
  .download-area {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .file-info {
    margin-bottom: 10px;
  }
  .content-layout1 {
    display: flex;
    padding: 0;
  }
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  width: 100%;
}

.responsive-pagination {
  /* 确保分页组件自身也是居中的 */
  display: flex;
  justify-content: center;
}

/* 响应式调整 */
@media (max-width: 767px) {
  .pagination-container {
    margin: 20px 0;
  }
  
  /* 调整移动端分页按钮的间距 */
  :deep(.el-pagination) {
    padding: 0;
  }
  
  :deep(.el-pagination .btn-prev),
  :deep(.el-pagination .btn-next) {
    min-width: 28px;
  }
  
  :deep(.el-pagination .el-pager li) {
    min-width: 28px;
  }
}

/* 报告卡片样式 */
.content-layout {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.report-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.report-card:hover {
  background-color: #f9f9f9;
}

.report-content {
  flex: 1;
  padding-right: 30px;
}

.report-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0 0 15px 0;
  line-height: 1.4;
}

.report-summary {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.report-image {
  width: 140px;
  height: 90px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 4px;
}

.report-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.report-card:hover .report-image img {
  transform: scale(1.05);
}

/* 响应式样式 */
@media (max-width: 768px) {
  .report-card {
    padding: 20px 15px;
  }
  
  .report-content {
    padding-right: 15px;
  }
  
  .report-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  
  .report-summary {
    font-size: 13px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .report-image {
    width: 120px;
    height: 80px;
  }
}

@media (max-width: 480px) {
  .report-card {
    flex-direction: column-reverse;
    padding: 15px;
  }
  
  .report-content {
    padding-right: 0;
    padding-top: 15px;
    width: 100%;
  }
  
  .report-image {
    width: 100%;
    height: 160px;
    margin-bottom: 10px;
  }
  
  .report-title {
    font-size: 15px;
  }
  .hero-content {
    margin-top: 220px;
  }
  .search-box {
    margin-top: 10px;
  }
}

/* Markdown 内容样式 */
.markdown-content {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  line-height: 1.7;
  color: #333;
  padding: 25px;
  max-width: 900px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  min-height: 400px;
}

/* 标题样式 */
.markdown-content h1 {
  font-size: 28px;
  font-weight: 600;
  margin: 28px 0 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eaecef;
  color: #24292e;
  line-height: 1.3;
  overflow-wrap: break-word;
}

.markdown-content h2 {
  font-size: 22px;
  font-weight: 600;
  margin: 25px 0 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eaecef;
  color: #24292e;
  line-height: 1.35;
  overflow-wrap: break-word;
}

.markdown-content h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 22px 0 14px;
  color: #24292e;
  line-height: 1.4;
  overflow-wrap: break-word;
}

.markdown-content h4, .markdown-content h5, .markdown-content h6 {
  font-weight: 600;
  margin: 20px 0 12px;
  color: #24292e;
  line-height: 1.4;
  overflow-wrap: break-word;
}

/* 段落和列表样式 */
.markdown-content p {
  margin: 16px 0;
  line-height: 1.7;
  overflow-wrap: break-word;
}

.markdown-content ul, .markdown-content ol {
  padding-left: 28px;
  margin: 16px 0;
  line-height: 1.7;
}

.markdown-content li {
  margin: 8px 0;
  overflow-wrap: break-word;
}

.markdown-content li > ul, .markdown-content li > ol {
  margin: 8px 0;
}

/* 代码样式 */
.markdown-content code {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
  background-color: rgba(27, 31, 35, 0.05);
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 85%;
  margin: 0 2px;
  white-space: pre-wrap;
  word-break: break-all;
}

.markdown-content pre {
  background-color: #f6f8fa;
  border-radius: 6px;
  padding: 16px;
  overflow: auto;
  margin: 20px 0;
  line-height: 1.5;
  max-width: 100%;
}

.markdown-content pre code {
  background-color: transparent;
  padding: 0;
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  display: block;
  overflow-x: auto;
  color: #24292e;
  white-space: pre-wrap;
  word-break: break-all;
}

/* 表格样式 */
.markdown-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
  display: block;
  overflow-x: auto;
  max-width: 100%;
}

.markdown-content table th, .markdown-content table td {
  border: 1px solid #dfe2e5;
  padding: 10px 14px;
  line-height: 1.5;
  min-width: 80px;
  word-break: break-word;
}

.markdown-content table th {
  background-color: #f6f8fa;
  font-weight: 600;
  text-align: left;
}

.markdown-content table tr:nth-child(2n) {
  background-color: #f8f8f8;
}

/* 引用样式 */
.markdown-content blockquote {
  margin: 20px 0;
  padding: 0 20px;
  color: #6a737d;
  border-left: 4px solid #dfe2e5;
  font-style: italic;
  overflow-wrap: break-word;
}

.markdown-content blockquote > :first-child {
  margin-top: 0;
}

.markdown-content blockquote > :last-child {
  margin-bottom: 0;
}

/* 链接样式 */
.markdown-content a {
  color: #0366d6;
  text-decoration: none;
  transition: color 0.2s ease;
  word-break: break-all;
}

.markdown-content a:hover {
  text-decoration: underline;
  color: #0056b3;
}

/* 图片样式 */
.markdown-content img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 水平线样式 */
.markdown-content hr {
  height: 1px;
  background-color: #e1e4e8;
  border: none;
  margin: 24px 0;
}

/* 强调样式 */
.markdown-content strong {
  font-weight: 600;
  color: #24292e;
}

.markdown-content em {
  font-style: italic;
}

/* 代码块语言标记 */
.markdown-content pre::before {
  content: attr(data-lang);
  display: block;
  background: #e1e4e8;
  color: #24292e;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  margin: -16px -16px 16px -16px;
  border-radius: 6px 6px 0 0;
}

/* 长文本处理 */
.markdown-content * {
  max-width: 100%;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .markdown-content {
    padding: 20px;
    max-width: 95%;
  }
  
  .markdown-content h1 {
    font-size: 26px;
    margin: 25px 0 18px;
  }
  
  .markdown-content h2 {
    font-size: 20px;
    margin: 22px 0 14px;
  }
  
  .markdown-content h3 {
    font-size: 17px;
  }
  
  .markdown-content pre {
    padding: 14px;
  }
}

@media (max-width: 768px) {
  .markdown-content {
    padding: 18px;
    line-height: 1.6;
  }
  
  .markdown-content h1 {
    font-size: 24px;
    margin: 22px 0 16px;
    padding-bottom: 10px;
  }
  
  .markdown-content h2 {
    font-size: 19px;
    margin: 20px 0 12px;
    padding-bottom: 6px;
  }
  
  .markdown-content h3 {
    font-size: 16px;
    margin: 18px 0 10px;
  }
  
  .markdown-content p, .markdown-content ul, .markdown-content ol {
    margin: 14px 0;
    line-height: 1.6;
  }
  
  .markdown-content ul, .markdown-content ol {
    padding-left: 24px;
  }
  
  .markdown-content pre {
    padding: 14px;
    margin: 16px 0;
  }
  
  .markdown-content table th, .markdown-content table td {
    padding: 8px 12px;
  }
  
  .markdown-content blockquote {
    padding: 0 16px;
  }
}

@media (max-width: 480px) {
  .markdown-content {
    padding: 15px;
    line-height: 1.5;
    font-size: 15px;
  }
  
  .markdown-content h1 {
    font-size: 22px;
    margin: 20px 0 14px;
    padding-bottom: 8px;
  }
  
  .markdown-content h2 {
    font-size: 18px;
    margin: 18px 0 10px;
    padding-bottom: 5px;
  }
  
  .markdown-content h3 {
    font-size: 16px;
    margin: 16px 0 8px;
  }
  
  .markdown-content p, .markdown-content ul, .markdown-content ol {
    margin: 12px 0;
    line-height: 1.5;
  }
  
  .markdown-content ul, .markdown-content ol {
    padding-left: 20px;
  }
  
  .markdown-content li {
    margin: 6px 0;
  }
  
  .markdown-content pre {
    padding: 12px;
    margin: 14px 0;
    font-size: 13px;
  }
  
  .markdown-content code {
    font-size: 80%;
    padding: 2px 4px;
  }
  
  .markdown-content pre code {
    font-size: 13px;
  }
  
  .markdown-content table th, .markdown-content table td {
    padding: 6px 10px;
    font-size: 14px;
    min-width: 60px;
  }
  
  .markdown-content blockquote {
    padding: 0 12px;
    margin: 14px 0;
  }
  
  .markdown-content img {
    margin: 14px auto;
  }
}
</style> 